import $ from 'jquery';

(function($){

    jQuery(function(){

        if( jQuery('#wc_order_tip_updated_1_1').length ) {
            jQuery('#wc_order_tip_updated_1_1').parent().parent().hide();
        }
    
    });

})(jQuery);